export default "__VITE_ASSET__8f92478b__"